var EditDialogButton = require('./editDialogToggleButton');



module.exports = EditDialogButton.extend({
    topOffset: 20,     //temp offset from the other button -- static for now
    iconCode: 0xe809,
    color: '#3399FF',
    title: 'Properties'
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/redactionCodeBtn.js
 ** module id = 235
 ** module chunks = 0
 **/